import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "text-end" }

import { useRoute } from 'vue-router';
import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { error_message, success_message } from '@/components/common/toast';
import ApiServices from '@/services/apiServices';
import { useLoaderState } from '@/store/loading';
import type { socialNetwork } from '@/core/data/socialNetwork';

export default /*@__PURE__*/_defineComponent({
  __name: 'SocialNetworkEdit',
  setup(__props) {

let route = useRoute();
const { t } = useI18n();
const SocialNetworkEdit = defineAsyncComponent(
    () => import('@/components/theme/socialnetwork/SocialNetworkEdit.vue'),
);
let socialNetwork = ref<socialNetwork>({
    id: '',
    title: '',
    type: 'FACEBOOK',
    url: '',
    imageUrl: undefined,
    createdAt: new Date(),
    createdBy: undefined,
    updatedAt: new Date(),
    updatedBy: undefined,
});

const title = computed(() => {
    return socialNetwork.value && socialNetwork.value.id
        ? t('socialNetWorkEdit.updatetitle')
        : t('socialNetWorkEdit.addtitle');
});
const save = async () => {
    if (!socialNetwork.value.title) {
        error_message(t('socialNetWorkEdit.titleRequired'));
        return;
    }
    if (!socialNetwork.value.url || !/^https?:\/\//i.test(String(socialNetwork.value.url))) {
        error_message(t('socialNetWorkEdit.urlInvalid'));
        return;
    }
    useLoaderState().changeStateTrue();
    if (route.query.id !== undefined) {
        //@ts-ignore
        ApiServices.update(
            'socialNetworks',
            socialNetwork.value,
            socialNetwork.value.id,
        )
            .then(() => {
                success_message(t('socialNetWorkEdit.updated'));
            })
            .catch((ex) => {
                error_message(ex);
            })
            .finally(() => {
                useLoaderState().changeStateFalse();
            });
    } else {
        ApiServices.create('socialNetworks', socialNetwork.value)
            .then(() => {
                success_message(t('socialNetWorkEdit.saved'));
            })
            .catch((ex) => {
                error_message(ex);
            })
            .finally(() => {
                useLoaderState().changeStateFalse();
            });
    }
};
const getDatas = async () => {
    if (route.query.id !== undefined) {
        ApiServices.getById('socialNetworks', route.query.id.toString()).then(
            (response: any) => {
                socialNetwork.value = response;
            },
        );
    }
};
onMounted(() => {
    useLoaderState().changeStateTrue();
    getDatas();
    useLoaderState().changeStateFalse();
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Card3 = _resolveComponent("Card3")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Réseau social",
      mains: title.value,
      title: "Accueil"
    }, null, 8, ["mains"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Card3, { colClass: "col-sm-12" }, {
          default: _withCtx(() => [
            _createVNode(_unref(SocialNetworkEdit), { socialNetwork: _unref(socialNetwork) }, null, 8, ["socialNetwork"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    class: "btn btn-success me-1",
                    target: "_blank",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (save()))
                  }, _toDisplayString(_ctx.$t('save')), 1)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})